import { Grid, GridAreas, Heading } from '@dreryk/react-components';

import { FirstNameField } from '../../../components/FirstNameField';
import { LastNameField } from '../../../components/LastNameField';
import { invoiceCreateModalTranslationKeys } from '../../../translations';
import { InvoiceCreateFormRegisterControllerProp } from '../InvoiceCreateForm.types';

type PRIVATE_INDIVIDUAL_GRID_AREA = 'firstName' | 'lastName';

const PRIVATE_INDIVIDUAL_GRID_COLUMNS = 2;
const GRID_GAP = '24px 36px';

const PRIVATE_INDIVIDUAL_GRID_AREAS: GridAreas<PRIVATE_INDIVIDUAL_GRID_AREA, typeof PRIVATE_INDIVIDUAL_GRID_COLUMNS> = {
   custom: {
      template: ['firstName lastName'],
      gridTemplateColumns: '462px 462px',
      gap: GRID_GAP,
   },
};

type InvoiceCreateFormPrivateIndividualSectionProps = InvoiceCreateFormRegisterControllerProp;

export const InvoiceCreateFormPrivateIndividualSection = (
   props: InvoiceCreateFormPrivateIndividualSectionProps
): JSX.Element => {
   const { register } = props;

   return (
      <section>
         <Heading
            content={invoiceCreateModalTranslationKeys.privateIndividualDetails}
            testId={'privateIndividualDetails'}
            type={'h2'}
            margin={'18px'}
         />
         <Grid<PRIVATE_INDIVIDUAL_GRID_AREA, typeof PRIVATE_INDIVIDUAL_GRID_COLUMNS>
            areas={PRIVATE_INDIVIDUAL_GRID_AREAS}
            testId={'privateIndividualGrid'}
            firstName={<FirstNameField register={register} />}
            lastName={<LastNameField register={register} />}
         />
      </section>
   );
};
